import { useEffect, useRef } from 'react'

/**
 * This hook is used to determine if a component is mounted.
 * Use this to check before setting state instead of using local 'isMounted' variables all over our useEffects.
 * @note Check the value of `.current` on the returned object where it's used
 * @source https://codedamn.com/news/reactjs/cant-perform-a-react-state-update-error
 */
export default function useIsComponentMounted() {
  const isComponentMountedRef = useRef(false)

  useEffect(() => {
    isComponentMountedRef.current = true
    return () => {
      isComponentMountedRef.current = false
    }
  }, [])

  return isComponentMountedRef
}
